import Lottie from 'lottie-react'
import walkAnimation from '../../assets/animations/walk.json'

interface WalkingIconProps {
  className?: string
  size?: number
  direction?: 'right' | 'down'
}

const WalkingIcon = ({ className = "w-8 h-8", size, direction = 'right' }: WalkingIconProps) => {
  const rotation = direction === 'right' ? 'rotate-90' : 'rotate-180'

  return (
    <div className={className} style={{ aspectRatio: '1 / 1', contain: 'layout' }}>
      <div className={`transform ${rotation} text-primary-600 dark:text-primary-400 w-full h-full`}>
        <div className="dark:invert dark:brightness-0 dark:contrast-200 w-full h-full">
          <Lottie
            animationData={walkAnimation}
            loop={true}
            autoplay={true}
            style={{ width: size || '100%', height: size || '100%' }}
            rendererSettings={{
              preserveAspectRatio: 'xMidYMid meet'
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default WalkingIcon